'use strict';
(function (angular) {
	angular.module('PinMeTo.UI').component('pmtCard', {
		templateUrl: 'pmtShared/pmtUi/Card.html',
		transclude: {
			headerSlot: '?pmtCardHeader',
			overlaySlot: 'pmtCardOverlay',
			imgSlot: 'img'
		},
		bindings: {
			clamp: '=',
			overlayOnly: '<'
		}
	});
})(window.angular);
